<template>
  <v-card class="popup-card">
    <v-card-title v-if="popup.title" class="popup-title">{{
      popup.title
    }}</v-card-title>
    <v-card-text>
      <p>La tua Spesa è completata!</p>
      <p>Recati in cassa per il checkout</p>
      <!-- <p>Recati al banco informazioni, presentando il numero d'ordine:</p>
      <div class="justify-center d-flex">
        <h2>{{ popup.orderId }}</h2>
      </div> -->
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn color="primary" depressed min-width="150" @click="submit()"
        >Esci</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<style lang="scss">
.v-dialog.vuedl-layout {
  .popup-card.v-card {
    .v-card__text {
      padding-top: 10px !important;
    }
  }
}
.popup-card {
  .popup-title {
    font-size: 20px;
  }
}
</style>

<script>
import { mapActions } from "vuex";

export default {
  name: "SelfscanningCompleted",
  props: {
    popup: { type: Object, required: true }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      setPopupMap: "app/setPopupMap"
    }),
    submit() {
      this.setPopupMap(this.categoryId + "" + this.popup.TITLE);
      this.$emit("submit", true);
    }
  }
};
</script>
